module.exports = __webpack_public_path__ + "media/images/site/infantil_pais-aa73600a2d9fb97d0aa345e3fcf9a0a3.jpg";